import React, { useState } from "react";

const BrandAccordion = ({ title, content }) => {
    const [isAccordionOpen, setIsAccordionOpen] = useState(false);
    return (
        <div className="brand__accordion" style={{ marginBottom: "20px" }}>
            <div 
            className="brand__accordion-title"
            onClick={() => setIsAccordionOpen(!isAccordionOpen)}
            >
                <h4>
                    {title}
                    <span className="accordion__icon">
                        {isAccordionOpen ? "-" : "+"}
                    </span>
                </h4>
            </div>
            { isAccordionOpen ? (
                <div 
                    className="brand__accordion-content"
                    dangerouslySetInnerHTML={{ __html: content }} // ✅ Correct Usage
                />
            ) : null}
        </div>
    );
}


export default BrandAccordion;